{
  "hero": {
    "eyebrow": "动态",
    "title": "第一阶段建造日志",
    "lead": "公开里程碑遵循项目计划。条目为计划状态，直至后续文档确认完成。"
  },
  "list": { "title": "里程碑" },
  "detail": { "back": "返回动态", "related": "更多动态" },
  "items": {
    "phase-one-kickoff": {
      "date": "2026.09",
      "tag": "计划中",
      "title": "立项、熟悉与部件验证",
      "summary": "敲定第一阶段范围、架构、安全流程、采购记录与基础部件检查。",
      "body": [
        "九月确认需求、CAD 与电气方案、传感计划、软件大纲与测试清单。",
        "各队熟悉工具并验证部件，尽早发现缺失或不可靠组件。"
      ]
    },
    "integrated-prototype": {
      "date": "2026.10",
      "tag": "计划中",
      "title": "并行子系统建造",
      "summary": "机械框架、电子台架测试与组件级软件模块准备集成。",
      "body": [
        "机械制造浮体平台与安装点；电气台架测试电源、传感器与通信；软件建立采集、控制与日志模块。",
        "月末就绪检查确认子系统可进入十一月受控水体集成。"
      ]
    },
    "controlled-water-testing": {
      "date": "2026.11",
      "tag": "计划中",
      "title": "集成与受控水体验证",
      "summary": "跨队测试浮力、防水、推进、校准、日志与首个可视化流水线。",
      "body": [
        "十一月从组件工作转向受控水体中的整机行为。",
        "失败、纠正措施与剩余风险在十二月验证前记录在案。"
      ]
    },
    "approved-pond-window": {
      "date": "2026.12",
      "tag": "有条件",
      "title": "全系统验证与可选校园静水演示",
      "summary": "完成受控水体测试事件；校园静水测试仅在许可、天气与安全允许时进行。",
      "body": [
        "受控水体验证是必达目标。获批校园水体测试仍为冲刺结果。",
        "产出包括可用 CSV 日志、路线/趋势可视化，以及在数据质量允许时至少一幅空间可视化。"
      ]
    },
    "ams-report-archive": {
      "date": "2027.01",
      "tag": "计划中",
      "title": "最终报告与交接档案",
      "summary": "于 2027 年 1 月 31 日前提交最终项目报告与整理档案。",
      "body": [
        "一月聚焦报告而非新硬件开发。",
        "档案涵盖 CAD、布线、代码、校准、试验、安全、维护与后续阶段建议。"
      ]
    }
  }
}
